import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-cd4",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-cd4.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-cd4.component.less",
})
export class PrefixCd4Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super({
      defaultValue: "0000000",
      updateOn: "blur",
    });
    this.maxlength = 7;
    this.required = false;
    this.characters = ALLOWED_CHARACTERS["cd4"];
  }
}
